const TOKEN_KEY = 'WUCHANG_FRONT_TOKEN'
const USER_KEY = 'WUCHANG_FRONT_USER'
const REMEMBER_KEY = 'WUCHANG_FRONT_REMEMBER'

function getStorage() {
  return window.localStorage
}

function encodePassword(password) {
  return window.btoa(unescape(encodeURIComponent(password || '')))
}

function decodePassword(password) {
  return decodeURIComponent(escape(window.atob(password || '')))
}

export function getToken() {
  return getStorage().getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  getStorage().setItem(TOKEN_KEY, token)
}

export function removeToken() {
  getStorage().removeItem(TOKEN_KEY)
}

export function setUserProfile(user) {
  const profile = {
    userId: user.userId || null,
    deptId: user.deptId || null,
    userName: user.userName || '',
    nickName: user.nickName || '',
    deptName: (user.dept && user.dept.deptName) || user.deptName || '',
    roles: Array.isArray(user.roles) ? user.roles : [],
    permissions: Array.isArray(user.permissions) ? user.permissions : []
  }
  getStorage().setItem(USER_KEY, JSON.stringify(profile))
}

export function getUserProfile() {
  const raw = getStorage().getItem(USER_KEY)
  if (!raw) {
    return {}
  }

  try {
    return JSON.parse(raw)
  } catch {
    getStorage().removeItem(USER_KEY)
    return {}
  }
}

export function removeUserProfile() {
  getStorage().removeItem(USER_KEY)
}

export function saveRememberedLogin(form) {
  const remembered = {
    username: form.username || '',
    password: encodePassword(form.password || ''),
    rememberMe: true
  }
  getStorage().setItem(REMEMBER_KEY, JSON.stringify(remembered))
}

export function getRememberedLogin() {
  const raw = getStorage().getItem(REMEMBER_KEY)
  if (!raw) {
    return null
  }

  try {
    const remembered = JSON.parse(raw)
    return {
      username: remembered.username || '',
      password: decodePassword(remembered.password || ''),
      rememberMe: Boolean(remembered.rememberMe)
    }
  } catch {
    getStorage().removeItem(REMEMBER_KEY)
    return null
  }
}

export function clearRememberedLogin() {
  getStorage().removeItem(REMEMBER_KEY)
}

export function clearAuthState() {
  removeToken()
  removeUserProfile()
}
